import { render } from "./ForbiddenView.vue?vue&type=template&id=6eae6463"
import script from "./ForbiddenView.vue?vue&type=script&lang=js"
export * from "./ForbiddenView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__